import { addGlobalEventProcessor, Event, getCurrentHub } from '@sentry/browser';
import { getUrlParts } from '../../getUrlParts';
import { debugMessage } from '../debugMessage';

export class S4MPEventFilter {
  public static id: string = 'S4MPEventFilter';
  public name: string = S4MPEventFilter.id;

  setupOnce() {
    debugMessage('sentry: setting up S4MPEventFilter integration');
    addGlobalEventProcessor(ev => {
      const self = getCurrentHub().getIntegration(S4MPEventFilter);
      if (this._isS4mpStacktrace(ev) || !self) {
        const { basePath, locale } = getUrlParts(window.location.pathname);
        if (!ev.tags) {
          ev.tags = {};
        }
        ev.tags.s4mpApp = basePath || 's4mp-micro-frontends';
        ev.tags.locale = locale;
        debugMessage('sentry: capturing s4mp event...');
        return ev;
      }
      debugMessage('sentry: filtering out non-s4mp event...');
      return null;
    });
  }
  private _isS4mpStacktrace(ev: Event) {
    try {
      // check first frame in stacktrace to see if the pathname includes an app basepath.
      // if it does not, the error originates from s4mp
      const stacktraceUrl = new URL(
        ev.exception!.values![0].stacktrace!.frames![0].filename!,
      );
      const { basePath } = getUrlParts(stacktraceUrl.pathname);
      return !basePath;
    } catch {
      // We can't tell if this is an s4mp event or not- log it to the s4mp project just in case
      return true;
    }
  }
}
